module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tablesWrap",
    attrs: {
      "id": "tablesWrap"
    }
  }, _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      staticClass: "tableContent"
    }, [(item.template === 'team_point_ranking_match') ? _c('div', {
      staticClass: "ranking_match_wrap"
    }, [_c('p', {
      staticClass: "fourthTit"
    }, [_vm._v(_vm._s(item.content.name))]), _vm._v(" "), _vm._l((item.content.data), function(elem, index) {
      return _c('div', {
        staticClass: "list clearfix"
      }, [_c('span', {
        staticClass: "date"
      }, [_vm._v(_vm._s(elem.finalIneedTime.finalTime_md_hm))]), _vm._v(" "), _c('p', {
        staticClass: "teamA clearfix"
      }, [_c('span', {
        staticClass: "teamA_name"
      }, [_vm._v(_vm._s(elem.team_A_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamA_logo",
        attrs: {
          "src": _vm.getImgSrc(elem.team_A_logo)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "score"
      }, [(elem.status == 'Cancelled' || elem.status == 'Postponed' || elem.status == 'Suspended' || item.status == 'Uncertain') ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v(" "), (elem.status == 'Fixture' || elem.status == 'Playing') ? _c('span', [_vm._v("VS")]) : _vm._e(), _vm._v(" "), (elem.status == 'Played' || elem.status == 'Playing') ? _c('span', {
        class: {
          'colorGreen': elem.status == 'Playing'
        }
      }, [_vm._v(_vm._s(elem.fs_A) + " : " + _vm._s(elem.fs_B))]) : _vm._e()]), _vm._v(" "), _c('p', {
        staticClass: "teamB clearfix"
      }, [_c('span', {
        staticClass: "teamB_name"
      }, [_vm._v(_vm._s(elem.team_B_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamB_logo",
        attrs: {
          "src": _vm.getImgSrc(elem.team_B_logo)
        }
      })])])
    })], 2) : _vm._e(), _vm._v(" "), (item.template === 'team_point_ranking_aggregate') ? _c('div', {
      staticClass: "ranking_aggregate_wrap"
    }, [_c('p', {
      staticClass: "fourthTit"
    }, [_vm._v(_vm._s(item.content.name))]), _vm._v(" "), _vm._l((item.content.data), function(aggregate, num) {
      return _c('div', {
        staticClass: "aggregate_wrap"
      }, [_c('div', {
        staticClass: "list bgGray1 clearfix"
      }, [_c('span', {
        staticClass: "date padLTotal"
      }, [_vm._v("Total")]), _vm._v(" "), _c('p', {
        staticClass: "teamA clearfix"
      }, [_c('span', {
        staticClass: "teamA_name"
      }, [_vm._v(_vm._s(aggregate.total.team_A_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamA_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.total.team_A_logo)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "score"
      }, [_c('span', [_vm._v(_vm._s(aggregate.total.fs_A) + " : " + _vm._s(aggregate.total.fs_B))])]), _vm._v(" "), _c('p', {
        staticClass: "teamB clearfix"
      }, [_c('span', {
        staticClass: "teamB_name"
      }, [_vm._v(_vm._s(aggregate.total.team_B_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamB_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.total.team_B_logo)
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "list bgGray2 clearfix"
      }, [_c('span', {
        staticClass: "date"
      }, [_vm._v(_vm._s(aggregate.match1.finalIneedTime.finalTime_md_hm))]), _vm._v(" "), _c('p', {
        staticClass: "teamA clearfix"
      }, [_c('span', {
        staticClass: "teamA_name"
      }, [_vm._v(_vm._s(aggregate.match1.team_A_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamA_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.match1.team_A_logo)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "score"
      }, [(aggregate.match1.status == 'Cancelled' || aggregate.match1.status == 'Postponed' || aggregate.match1.status == 'Suspended' || aggregate.match1.status == 'Uncertain') ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v(" "), (aggregate.match1.status == 'Fixture' || aggregate.match1.status == 'Playing') ? _c('span', [_vm._v("VS")]) : _vm._e(), _vm._v(" "), (aggregate.match1.status == 'Played' || aggregate.match1.status == 'Playing') ? _c('span', {
        class: {
          'colorGreen': aggregate.match1.status == 'Playing'
        }
      }, [_vm._v(_vm._s(aggregate.match1.fs_A) + " : " + _vm._s(aggregate.match1.fs_B))]) : _vm._e()]), _vm._v(" "), _c('p', {
        staticClass: "teamB clearfix"
      }, [_c('span', {
        staticClass: "teamB_name"
      }, [_vm._v(_vm._s(aggregate.match1.team_B_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamB_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.match1.team_B_logo)
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "list bgGray2 clearfix"
      }, [_c('span', {
        staticClass: "date"
      }, [_vm._v("\n        " + _vm._s(aggregate.match2.finalIneedTime.finalTime_md_hm))]), _vm._v(" "), _c('p', {
        staticClass: "teamA clearfix"
      }, [_c('span', {
        staticClass: "teamA_name"
      }, [_vm._v(_vm._s(aggregate.match2.team_A_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamA_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.match2.team_A_logo)
        }
      })]), _vm._v(" "), _c('p', {
        staticClass: "score"
      }, [(aggregate.match2.status == 'Cancelled' || aggregate.match2.status == 'Postponed' || aggregate.match2.status == 'Suspended' || aggregate.match2.status == 'Uncertain') ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v(" "), (aggregate.match2.status == 'Fixture' || aggregate.match2.status == 'Playing') ? _c('span', [_vm._v("VS")]) : _vm._e(), _vm._v(" "), (aggregate.match2.status == 'Played' || aggregate.match2.status == 'Playing') ? _c('span', {
        class: {
          'colorGreen': aggregate.match2.status == 'Playing'
        }
      }, [_vm._v(_vm._s(aggregate.match2.fs_A) + " : " + _vm._s(aggregate.match2.fs_B))]) : _vm._e()]), _vm._v(" "), _c('p', {
        staticClass: "teamB clearfix"
      }, [_c('span', {
        staticClass: "teamB_name"
      }, [_vm._v(_vm._s(aggregate.match2.team_B_name))]), _c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "teamB_logo teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(aggregate.match2.team_B_logo)
        }
      })])])])
    })], 2) : _vm._e(), _vm._v(" "), (item.template === 'team_point_ranking_group') ? _c('div', {
      staticClass: "ranking_group_wrap"
    }, [_c('p', {
      staticClass: "fourthTit bgGray1"
    }, [_vm._v(_vm._s(item.content.name))]), _vm._v(" "), _vm._l((item.content.data), function(group, groupIndex) {
      return _c('div', {
        staticClass: "groupWrap"
      }, [_c('p', {
        staticClass: "fourthTit"
      }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('div', {
        staticClass: "teamWrap"
      }, [_c('p', {
        staticClass: "teamHeader"
      }, [_c('span', {
        staticClass: "teamHeader0"
      }), _vm._v(" "), _c('span', {
        staticClass: "teamHeader1"
      }, [_vm._v(_vm._s(group.header[0]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader2"
      }, [_vm._v(_vm._s(group.header[1]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader3"
      }, [_vm._v(_vm._s(group.header[2]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader4"
      }, [_vm._v(_vm._s(group.header[3]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader5"
      }, [_vm._v(_vm._s(group.header[4]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader6"
      }, [_vm._v(_vm._s(group.header[5]))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader7"
      }, [_vm._v(_vm._s(group.header[6]))])]), _vm._v(" "), _vm._l((group.data), function(grouplist, groupListIndex) {
        return _c('p', {
          staticClass: "teambodylist",
          class: {
            'topGreen': (groupListIndex < group.top), 'endGray': (groupListIndex >= (group.data.length - group.end))
          }
        }, [_c('span', {
          staticClass: "teamHeader0"
        }, [_vm._v(_vm._s(groupListIndex + 1))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader1 clearfix"
        }, [_c('img', {
          directives: [{
            name: "team-logo",
            rawName: "v-team-logo"
          }],
          staticClass: "team_icon teamCompete_icon",
          attrs: {
            "data-src": _vm.getImgSrc(grouplist.team_logo)
          }
        }), _c('b', [_vm._v(_vm._s(grouplist.team_name))])]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader2"
        }, [_vm._v(_vm._s(grouplist.matches_total))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader3"
        }, [_vm._v(_vm._s(grouplist.matches_won))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader4"
        }, [_vm._v(_vm._s(grouplist.matches_draw))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader5"
        }, [_vm._v(_vm._s(grouplist.matches_lost))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader6"
        }, [_vm._v(_vm._s(grouplist.goals_pro) + "/" + _vm._s(grouplist.goals_against))]), _vm._v(" "), _c('span', {
          staticClass: "teamHeader7"
        }, [_vm._v(_vm._s(grouplist.points))])])
      })], 2)])
    })], 2) : _vm._e(), _vm._v(" "), (item.template === 'team_point_ranking_regular') ? _c('div', {
      staticClass: "League_match_wrap"
    }, [(item.content.name) ? _c('p', {
      staticClass: "fourthTit"
    }, [_vm._v(_vm._s(item.content.name))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "teamWrap"
    }, [_c('p', {
      staticClass: "teamHeader"
    }, [_c('span', {
      staticClass: "teamHeader0"
    }), _vm._v(" "), _c('span', {
      staticClass: "teamHeader1"
    }, [_vm._v(_vm._s(item.content.header[0]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader2"
    }, [_vm._v(_vm._s(item.content.header[1]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader3"
    }, [_vm._v(_vm._s(item.content.header[2]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader4"
    }, [_vm._v(_vm._s(item.content.header[3]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader5"
    }, [_vm._v(_vm._s(item.content.header[4]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader6"
    }, [_vm._v(_vm._s(item.content.header[5]))]), _vm._v(" "), _c('span', {
      staticClass: "teamHeader7"
    }, [_vm._v(_vm._s(item.content.header[6]))])]), _vm._v(" "), _vm._l((item.content.data), function(regular, index) {
      return _c('p', {
        staticClass: "teambodylist",
        class: {
          'topGreen': (index < item.content.top), 'endGray': (index >= (item.content.data.length - item.content.end))
        }
      }, [_c('span', {
        staticClass: "teamHeader0"
      }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader1 clearfix"
      }, [_c('img', {
        directives: [{
          name: "team-logo",
          rawName: "v-team-logo"
        }],
        staticClass: "team_icon teamCompete_icon",
        attrs: {
          "data-src": _vm.getImgSrc(regular.team_logo)
        }
      }), _c('b', [_vm._v(_vm._s(regular.team_name))])]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader2"
      }, [_vm._v(_vm._s(regular.matches_total))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader3"
      }, [_vm._v(_vm._s(regular.matches_won))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader4"
      }, [_vm._v(_vm._s(regular.matches_draw))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader5"
      }, [_vm._v(_vm._s(regular.matches_lost))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader6"
      }, [_vm._v(_vm._s(regular.goals_pro) + "/" + _vm._s(regular.goals_against))]), _vm._v(" "), _c('span', {
        staticClass: "teamHeader7"
      }, [_vm._v(_vm._s(regular.points))])])
    })], 2)]) : _vm._e()])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da1cd34e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table.vue
// module id = 684
// module chunks = 3